import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { Dialog } from 'vant'
import 'vant/lib/index.css'
// import VConsole from 'vconsole';

Vue.use(Dialog)

// new VConsole();
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
